import React, {lazy, Suspense} from 'react';
import {ColumnType} from '@pluto/table';
import CircularProgress from '@material-ui/core/CircularProgress';

import Table from '@pluto/table';

import './IngestList.scss';

export interface IngestListProps {
    onDebouncedSearch: () => void,
    handlePartnersChange: () => void,
    handleTypeChange: () => void,
    handleStatusChange: () => void,
    handleValidationStatusChange: () => void,
    handleIngestTypeChange: () => void,
    handleLabPartnerChange: () => void,
    title: string,
    filters: {
        contentPartnerId: string,
        type: string,
        status: string,
        validationStatus: string,
        labPartner: string,
        ingestType: string,
    },
    ingestList: string[],
    total: number,
    onPaging: () => void,
    page: number,
    setPage: (val: number) => void,
    rowsPerPage: number,
    setRowsPerPage: (val: number) => void,
    cols: ColumnType[],
}
const IngestListToolbar = lazy(() => import('./IngestListToolbar'));

export default function IngestList(props: IngestListProps) {
    const {
        onDebouncedSearch,
        handlePartnersChange,
        handleTypeChange,
        handleStatusChange,
        handleValidationStatusChange,
        handleLabPartnerChange,
        handleIngestTypeChange,
        title,
        filters,
        ingestList,
        total,
        onPaging,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        cols,
    } = props;
    return (
        <div className="ingest-container">
            <Suspense fallback={<CircularProgress />}>
                <IngestListToolbar
                    handleNameChange={onDebouncedSearch}
                    handlePartnersChange={handlePartnersChange}
                    handleLabPartnerChange={handleLabPartnerChange}
                    handleIngestTypeChange={handleIngestTypeChange}
                    handleTypeChange={handleTypeChange}
                    handleStatusChange={handleStatusChange}
                    handleValidationStatusChange={handleValidationStatusChange}
                    title={title}
                    filters={filters}
                />
            </Suspense>
            <Table
                data={ingestList}
                columns={cols}
                total={total}
                onChangePageHandler={onPaging}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
            />
        </div>
    );
}

